import { createSlice } from '@reduxjs/toolkit';
const initState = {
    chatWindowVisible: false,
    chatWindowInfo: undefined,
    waimaoToWaToolStatus: undefined,
};
const waSlicer = createSlice({
    name: 'waReducer',
    initialState: initState,
    reducers: {
        openWaChatWindow: (state, action) => {
            state.chatWindowVisible = true;
            state.chatWindowInfo = action.payload;
        },
        closeWaChatWindow: state => {
            state.chatWindowVisible = false;
            state.chatWindowInfo = undefined;
        },
        updateWaimaoToWaToolStatus: (state, action) => {
            state.waimaoToWaToolStatus = action.payload.status;
        },
    },
});
export const { actions } = waSlicer;
export default waSlicer.reducer;
